import React from 'react';
/*
This component is used in
components/pages/api/api.jsx
components/pages/defaultsettings/card.jsx
components/pages/live/floorplan.jsx
components/pages/live/sensorform.jsx
components/pages/overview/index.jsx
components/pages/settings/myaccount/password.jsx
components/pages/user/userlist.jsx
*/
import { getMenuHeight } from "components/common/utils.js"

export default class Modal extends React.Component {
	constructor(props, context) {
		super(props, context);
		this.state = {
			loaded: false,
			open: false,
			modalTopPosition: 0
		};
		this.offsetTop = this.offsetTop.bind(this);
	}

	componentDidMount() {
		let offsetTop = getMenuHeight("app_header") + getMenuHeight("sticky-menu");
		this.setState({
			modalTopPosition: offsetTop
		})
		window.addEventListener("scroll", this.offsetTop);
	}
	componentWillUnmount() {
		window.removeEventListener("scroll", this.offsetTop);
	}
	offsetTop() {
		/* check if the app header contains app_header--sticky, no need to update the state
		 if the app header is sticky*/
		if (!document.getElementById("app-header-id").classList.contains("app_header--sticky")) {
			var scrollTop = (document.body.scrollTop || document.documentElement.scrollTop);
			var offsetTop = Math.max(65 - scrollTop, 0);
			this.setState({
				modalTopPosition: offsetTop + getMenuHeight("sticky-menu")
			});
		}
	}
	toggle(e) {
		if (this.state.open) {
			this.close(e);
		} else {
			this.open(e);
		}
	}

	open(e) {
		if (!this.state.open) {
			if (typeof this.props.onOpen == "function") {
				this.props.onOpen(e);
			}

		}
		this.setState({ open: true, loaded: true });

	}

	close(e) {
		if (this.state.open) {
			if (typeof this.props.onClose == "function") {
				this.props.onClose(e);
			}
		}
		this.setState({ open: false, loaded: true });
	}

	render() {
		let type = "hidden";
		if (this.state.loaded) {
			type = this.state.open ? "open" : "closed";
		}

		return (

			<div className={`modals ${this.props.className ? this.props.className : ''}`}>
				{this.props.entry &&
					<div className="modals__entry" onClick={this.toggle.bind(this)}>
						{this.props.entry}
					</div>
				}
				<div className={"modals__overlay " + type} onClick={this.toggle.bind(this)}></div>
				<div className={"modals__content " + type} style={{ top: `${this.state.modalTopPosition}px` }}>
					<div className="modals__content__header">
						<button className="close" onClick={this.toggle.bind(this)}>×</button>
						<h4 className="modals__content__header__title">{this.props.header}</h4>
					</div>
					<div className={`modals__content__body`}>
						{this.props.children}
					</div>
					<div className="modals__content__footer">
						{!this.props.disableCloseButton &&
							<button className="btn btn-default" type="button" onClick={this.toggle.bind(this)}>Cancel</button>
						}
						<button className={"btn " + this.props.buttonClass || ""} type="button" onClick={this.props.clickButton}>
							{this.props.buttonText}
						</button>
					</div>
				</div>
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./src/components/common/modal.jsx